// extracted by mini-css-extract-plugin
export default {"Input":"input_Input__xfgry","Label":"input_Label__tDLBp"};